import * as React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { adminFetch } from "../../services/adminFetch";

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  const loc = useLocation();
  const { locale } = useParams<{ locale: string }>();
  const [status, setStatus] = React.useState<"loading" | "ok" | "no">("loading");

  React.useEffect(() => {
    let alive = true;
    adminFetch("/api/admin/auth/me")
      .then((res) => { if (alive) setStatus(res.ok ? "ok" : "no"); })
      .catch(() => { if (alive) setStatus("no"); });
    return () => { alive = false; };
  }, []);

  if (status === "loading") return null;

  if (status === "no") {
    const base = `/${locale || "el"}/admin/login`;
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`${base}?next=${next}`} replace />;
  }

  return <>{children}</>;
}
